<template>
  <div>
    <row v-for="(item,i) in name" :name="item" :data="that[`config${i+1}`].arr" :teamIndex.sync="that[`config${i+1}`].index"
         :key="'secondCategory'+i"
         v-if="i==0||(i<$parent.secondCategoryi&&that[`config${i}`].index&&that[`config${i+1}`].arr.length>1)"></row>
  </div>
</template>

<script>
  import { apiTeam } from "@/api/apiScreen.js"
  import sessionStorage from "@/storage/sessionStorage"
	export default {
		name: "secondCategory",
    components: {
      row: () => import("./row"),
    },
		data() {
			return {
			  name:['工程分类','工程专项','专业分类','分项工程','子项工程','子分项工程'],
        that:this,
        config1:{
          arr:[],
          index:''
        },
        config2:{
          arr:[],
          index:''
        },
        config3:{
          arr:[],
          index:''
        },
        config4:{
          arr:[],
          index:''
        },
        config5:{
          arr:[],
          index:''
        },
        config6:{
          arr:[],
          index:''
        },
			}
		},
		watch: {},
		created() {
			this.findCategoryListTree() 
		},
		methods: {
			//获取工程类别
			async findCategoryListTree() {
        if(!this.$store.state.HC_secondCategory){
          let res = await apiTeam.findCategoryListTree()
          this.createdata(res.data.data,1);
          this.setChange(res.data.data)
          this.$store.state.HC_secondCategory=res.data.data;
        }else{
          this.createdata(this.$store.state.HC_secondCategory,1);
          this.setChange(this.$store.state.HC_secondCategory)
        }
        this.getquery()
			},
      /* 设置激活项 */
      setChange(arr){
        if(!this.$store.state.firstCategoryNo) return
         let r= arr.findIndex(v => {
            return v.no == this.$store.state.firstCategoryNo
        })
         let obj = arr.find( v=> {
            return v.no == this.$store.state.firstCategoryNo
        })
          this[`config${1}`].index=r+1 //设置默认激活
          this.$parent.$refs.screen.secondCategory=[obj] //设置筛选项默认选中
          this.$nextTick(()=>{
            this.createdata(obj.children,2) //激活二级筛选
          })
      },
      createdata(data,type){
        if(type>6||!data)return;
			  this[`config${type}`].arr=[
          {
            children: null,
            grade: null,
            name: "全部",
            no: null,
            parentNo: null
          },
          ...data
        ]
        while(type<7){
          this[`config${type}`].index='';
          type++;
        }
      },
			/** @name 搜索单项 */
			send(name) {
			  let arr=[];
			  let index=this.name.indexOf(name)+1;
        if(index<6){
          let data=this[`config${index}`].arr[this[`config${index}`].index].children;
          if(!data)data=[];
          this.createdata(data,index+1)
        }
			  for(let i=1;i<index+1;i++){
			    if(this[`config${i}`].index){
            arr.push(this[`config${i}`].arr[this[`config${i}`].index])
          }else{
			      break;
          }
        }
				//添加搜索项
				this.$parent.$refs.screen.secondCategory=arr;
			},
      //读取搜索历史
      getquery(){
			  if(!this.$parent.getquery)return;
        //判断是否有筛选历史
        let query = sessionStorage.read('query')
        if(query) {
          query = JSON.parse(query)
          //判断是几级菜单
          let id={};
          if (query.type == 'one') {
            id.config1 = query.item.no
          }
          if (query.type == 'two') {
            id.config1 = query.parentId
            id.config2 = query.item.no
          }
          if (query.type == 'three') {
            id.config1 = query.firstNo
            id.config2 = query.secondNo
            id.config3 = query.third.no
          }
          for(let i=1;i<4;i++){
            let _i='';
            this[`config${i}`].arr.map((v,j)=>{
              if(v.no===id[`config${i}`])_i=j;
            })
            this[`config${i}`].index=_i;
            if(_i==='')break;
            this.createdata(this[`config${i}`].arr[this[`config${i}`].index].children,i+1)
          }
          this.send(this.name[this.name.length-1])
        }
      },
			/** @name 清队单项 */
			close(item) {
        item++;
        while(item<7){
          this[`config${item}`].index='';
          item++;
        }
			},
			/** @name 清空所有 */
			closeall() {
        let item=1;
        while(item<7){
          this[`config${item}`].index='';
          item++;
        }
			}
		},
	}
</script>

<style scoped>

</style>
